import { Button } from '@e2n/ui';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useNavigateToDate } from '../../../hooks/useNavigateToDate';
import { YearMonthParams } from '@/domain/termine/type';
import { useTranslation } from 'react-i18next';
import { YearMonthPopoverDesktop } from '@/domain/termine/components/YearMonthPicker/desktop/YearMonthPopoverDesktop';

export function YearMonthPickerDesktop({
  currentMonthAndYear,
}: {
  currentMonthAndYear: YearMonthParams;
}) {
  const switchToDate = useNavigateToDate();
  const { t } = useTranslation();
  const monthYearName = currentMonthAndYear.year + currentMonthAndYear.month;
  const prevMonth = dayjs(monthYearName).subtract(1, 'month');
  const nextMonth = dayjs(monthYearName).add(1, 'month');

  const handlePrevMonth = () => switchToDate(prevMonth);
  const handleNextMonth = () => switchToDate(nextMonth);
  const handleToday = () => switchToDate(dayjs());

  return (
    <div className="flex gap-2">
      <Button variant="outline-secondary" onClick={handleToday}>
        {t('general.date.today')}
      </Button>
      <div className="flex gap-1">
        <Button
          onClick={handlePrevMonth}
          variant="icon"
          size="icon"
          className="text-neutrals-700 text-xl">
          <FontAwesomeIcon icon={faChevronLeft} />
        </Button>
        <Button
          onClick={handleNextMonth}
          className="text-neutrals-700 text-xl"
          size="icon"
          variant="icon">
          <FontAwesomeIcon icon={faChevronRight} />
        </Button>
      </div>
      <YearMonthPopoverDesktop />
    </div>
  );
}
